var rmUtil = require("../rmlibrary_old/util");
var PDFCanvasNode = require("./canvas");
var PDFBlockNode = require("./block");
var extMap = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
};
function PDFImageNode(node) {
    var extMatch = node.src.match(/\.(\w+)(\?.*)?(#.*)?$/);
    var ext = (extMatch ? extMatch[1] : "png").toLowerCase();
    this.dataType = extMap[ext] || extMap.jpeg;
    PDFCanvasNode.apply(this, arguments);
}
rmUtil.inherits(PDFImageNode, PDFCanvasNode);
PDFImageNode.prototype.getDataUri = function (dataType) {
    if (this.originalNode.src && this.originalNode.src.indexOf("data:") === 0) {
        return this.originalNode.src;
    }
    var document = this.originalNode.ownerDocument;
    var canvas = document.createElement("canvas");
    var imageWidth = Number(this.originalNode.getAttribute("pdf-width")) ||
        this.originalNode.naturalWidth ||
        this.originalNode.width;
    var imageHeight = Number(this.originalNode.getAttribute("pdf-height")) ||
        this.originalNode.naturalHeight ||
        this.originalNode.height;
    canvas.width = imageWidth;
    canvas.height = imageHeight;
    var styles = PDFBlockNode.prototype._getOptions.call(this);
    var ctx = canvas.getContext("2d");
    if (styles.background) {
        ctx.fillStyle = styles.background;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.drawImage(this.originalNode, 0, 0, imageWidth, imageHeight);
    var dataUri = canvas.toDataURL(dataType);
    return dataUri;
};
module.exports = PDFImageNode;
//# sourceMappingURL=module.js.map